import {
  DISMISS_WARNING,
  WARNING_DISMISSED,
  WARNING_DISMISSAL_FAILED,
  AUTOMATIC_DISMISSAL
} from './actions';

const initialState = {
  isDismissing: false,
  isDismissed: false,
  error: null,
  warningType: null,
  dismissedAt: null,
  reason: null,
  failedAt: null
};

const warningDismissalReducer = (state = initialState, action) => {
  switch (action.type) {
    case DISMISS_WARNING:
      return {
        ...state,
        isDismissing: true,
        isDismissed: false,
        error: null,
        warningType: action.payload.warningType,
        reason: action.payload.reason
      };

    case WARNING_DISMISSED:
      return {
        ...state,
        isDismissing: false,
        isDismissed: true,
        warningType: action.payload.warningType,
        dismissedAt: action.payload.dismissedAt,
        reason: action.payload.reason,
        error: null,
        failedAt: null
      };

    case WARNING_DISMISSAL_FAILED:
      return {
        ...state,
        isDismissing: false,
        isDismissed: false,
        error: action.payload.error,
        failedAt: action.payload.failedAt
      };

    case AUTOMATIC_DISMISSAL:
      return {
        ...state,
        isDismissing: true,
        isDismissed: false,
        reason: action.payload.reason
      };

    default:
      return state;
  }
};

export default warningDismissalReducer;
